var options, users = {};

module.exports = function(parameters) {
    options = _.extend({
        '$searchInput'        : $('<input>'),

        api                   : $.noop,
        baseUrl               : '',
        friendsListParameters : {},
        facebookToken         : FB.getAccessToken(),
        noProfilePicture      : '',

        enter                 : $.noop,
        filter                : $.noop,
        appendUser            : $.noop,
        updateFriendScroll    : $.noop
    }, parameters);

    var hasLoadedUsers = !_.isEmpty(users);
    hasLoadedUsers && loadLocalFriends();
    hasLoadedUsers || loadRemoteFriends();
}

function loadLocalFriends() {
    _.each(users, options.appendUser);
    _.defer(allLoad);
}

function loadRemoteFriends() {
    var friendsSources = [
        { load: loadServerFriends },
        { load: loadFacebookFriends }
    ];
    var loadEnd = _.after(friendsSources.length, allLoad);
    _.invoke(friendsSources, 'load');

    function loadServerFriends() {
        $.post(
            options.baseUrl+'friends/list',
            options.friendsListParameters,
            onServerFriends
        );

        function onServerFriends(result) {
            var data = $.parseJSON(result);
            data.result && _.each(_.filter(data.result, isNewResult), addUser);

            loadEnd();
        }
    }

    function loadFacebookFriends() {
        var query = '/me/friends?fields=id,name,installed,picture.redirect(false).type(square)';
        query += '&access_token='+options.facebookToken;

        FB.api(query, function(response) {
            response && !response.error && _.each(response.data, function(itemData) {
                var data = {
                    username        : itemData.name,
                    social_user_id  : itemData.id,
                    profile_picture : itemData.picture.data.url
                };

                isNewResult(data) && addUser(data, 'Facebook');
            });

            loadEnd();
        });
    }
}

function allLoad() {
    options.updateFriendScroll();
    initSearch();
}

function isNewResult(itemData) {
    return !users[getItemId(itemData)];
}

function getItemId(itemData) {
    return itemData.social_user_id > 0 ? itemData.social_user_id : itemData.user_id;
}

function addUser(itemData, source) {
    var id = getItemId(itemData);
    var profilePic = itemData.profile_picture
        ? itemData.profile_picture.replace('344x344', '42x42')
        : options.noProfilePicture;

    users[id] = {
        user_id     : id,
        user_name   : itemData.username,
        profile_pic : profilePic
    };

    if(typeof source === 'string') users[id].source = source;
    options.appendUser(users[id]);
}

function initSearch() {
    var debouncedSearch = _.debounce(search, 800);
    var apiSearch = _.partial(options.api, 'search/user', 'GET');

    options.$searchInput.tagsinput({
        itemValue : 'id',
        itemText  : 'name'
    });

    options.$searchInput.tagsinput('input').keyup(function(event) {
        var query = options.$searchInput.tagsinput('input').val().trim();
        var keycode = event.keyCode ? event.keyCode : event.which;

        if(keycode == 13) {
            options.enter()
        }
        else {
            debouncedSearch();
            filter(true);
        }
    });

    function search() {
        var query = options.$searchInput.tagsinput('input').val().trim();

        query.length > 2 && apiSearch({ q: query }, function(result) {
            var newResults = _.filter(result, isNewResult);
            _.each(newResults, addUser);
            filter(false, query);
        });
    }

    function filter(isStillSearching, query) {
        query = typeof query === 'undefined'
            ? options.$searchInput.tagsinput('input').val().trim() : query;

        options.filter(query, isStillSearching);
    }
}
